import dayjs from 'dayjs';
import { QrCodeVisitStatus } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useMemo } from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useQrCodeVisits from 'v2/hooks/useQrCodeVisits/useQrCodeVisits';
import VisitsPageContent from 'v2/pages/Visits/components/VisitsPageContent';
import VisitsTable from 'v2/pages/Visits/components/VisitsTable';
import { useVisitsSearch } from '../useVisitsSearch';

const Cancelled: React.FC = () => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (message: string) => showSnackbar(message, { severity: 'error' });

  const { qrCodeVisits, loading } = useQrCodeVisits({ handleFetchError, translation });
  const visits = useMemo(() => {
    return qrCodeVisits
      .filter((visit) => visit.status === QrCodeVisitStatus.Cancelled)
      .sort((a, b) => dayjs(b.datetime).valueOf() - dayjs(a.datetime).valueOf());
  }, [qrCodeVisits]);
  const { filterStr, setFilterStr, filteredVisits, sections, chips, countCaption } = useVisitsSearch({ visits });

  return (
    <VisitsPageContent
      breadcrumbTitle={translation.cancelled}
      filterStr={filterStr}
      onFilterStrChange={setFilterStr}
      sections={sections}
      chips={chips}
      countCaption={countCaption}
      loading={loading}
      hasData={visits.length > 0}
      hasResults={filteredVisits.length > 0}
      table={<VisitsTable visits={filteredVisits} isLoading={loading} />}
      noDataTitle={translation.no_visits_found}
      noDataContent={translation.no_cancelled_visits_recorded}
    />
  );
};

export default Cancelled;
